import { connect, useDispatch } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import { Link, useHistory, withRouter } from "react-router-dom";
import { CircularProgress, Tooltip } from "@mui/material";
import {
  getNovedadesMenuByClienteId,
  marcarNovedadComoLeida,
} from "../../../actions/novedades";
import "./menu.css";
import { INovedad } from "../../../interface/novedades/INovedad";
import NotificationsIcon from "@mui/icons-material/Notifications";

const MenuNovedades = (props: any) => {
  const localSessionItem = window.localStorage.getItem("LocalSession");
  const local = localSessionItem ? JSON.parse(localSessionItem) : null;
  const [novedades, setNovedades] = useState<INovedad[]>([]);
  const noLeidas = useMemo(
    () => novedades.filter((n) => !n.leido).length,
    [novedades],
  );
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const handleClick = (novedadId: string) => {
    dispatch(
      marcarNovedadComoLeida({
        clienteId: local.clienteId.trim(),
        contactoId: local.contactoId,
        novedadId: novedadId,
      }),
    );

    if (props.novedades_menu.data) {
      localStorage.setItem(
        "novedadData",
        JSON.stringify(
          props.novedades_menu.data.$values.find(
            (novedad: INovedad) => novedad.id == novedadId,
          ),
        ),
      );
      history.push(`/novedad/${novedadId}`);
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    if (local.clienteId)
      dispatch(
        getNovedadesMenuByClienteId(local.clienteId.trim(), local.contactoId),
      );
  }, []);

  useEffect(() => {
    if (props.novedades_menu.data) {
      setNovedades(props.novedades_menu?.data.$values);
    }
    setLoading(false);
  }, [props.novedades_menu]);

  return (
    <li className="nav-item dropdown my-auto" style={{ marginRight: "0.7rem" }}>
      <a
        className="nav-link dropdown-toggle"
        style={{ textDecoration: "none", color: "white", cursor: "pointer" }}
        id="novedadesDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        Novedades &nbsp;&nbsp;
        {noLeidas > 0 && (
          <span
            style={{
              borderRadius: "50%",
              padding: "0.2em 0.58em",
              border: "1px solid white",
            }}
          >
            {noLeidas}
          </span>
        )}
      </a>
      <ul
        className="dropdown-menu dropdown-menu-end"
        aria-labelledby="novedadesDropdown"
        style={{ width: "18vw" }}
      >
        {loading && (
          <li style={{ textAlign: "center", padding: "1rem" }}>
            <CircularProgress size={20} />
          </li>
        )}

        {novedades.length === 0 && (
          <li
            style={{
              padding: "1rem",
              color: "#888",
              textAlign: "center",
              fontSize: "13px",
            }}
          >
            No hay novedades!
          </li>
        )}

        {novedades?.map((novedad) => (
          <li
            key={novedad.id}
            onClick={() => handleClick(novedad.id)}
            style={
              !novedad.leido
                ? { backgroundColor: "#f0f0f0", borderLeft: "3px solid #888" }
                : {}
            }
          >
            <Link className="textDecoration dropdown-item" to="#">
              <div className="row">
                <div className="padding-05 col-lg-3 col-md-3 mb-3">
                  <img
                    src={novedad.link}
                    alt={novedad.titulo}
                    height={"45px"}
                    style={{ marginTop: "1.2vw" }}
                  />
                </div>
                <div className="padding-1 col-lg-9 col-md-9 mb-9">
                  <div
                    className="truncate-text-7"
                    style={!novedad.leido ? { marginTop: "-0.9vw" } : {}}
                  >
                    {!novedad.leido && (
                      <Tooltip title="No leída">
                        <div aria-label="settings">
                          <NotificationsIcon style={{ height: 15 }} />
                        </div>
                      </Tooltip>
                    )}
                    {novedad.fechaCortaCreacion}
                  </div>
                  <div
                    className="truncate-text-12"
                    style={!novedad.leido ? { fontWeight: "600" } : {}}
                  >
                    {novedad.titulo}
                  </div>
                  <div className="truncate-text-08">{novedad.textoPortada}</div>
                </div>
              </div>
            </Link>
          </li>
        ))}

        {novedades.length > 0 && (
          <li style={{ borderTop: "1px solid #eee", marginTop: "4px" }}>
            <Link
              className="dropdown-item"
              to="/novedades"
              style={{ textAlign: "right", fontSize: "12px" }}
            >
              Ver todos →
            </Link>
          </li>
        )}
      </ul>
    </li>
  );
};

export default withRouter(
  connect(
    (state: any) => ({
      novedades_menu: state.novedades.novedades_menu,
      loading: state.novedades.loading,
    }),
    (dispatch) => ({
      getNovedadesMenuByClienteId: (clienteId: number, contactoId: number) =>
        dispatch(getNovedadesMenuByClienteId(clienteId, contactoId)),
      marcarNovedadComoLeida: (
        clienteId: string,
        contactoId: number,
        novedadId: number,
      ) =>
        dispatch(marcarNovedadComoLeida({ clienteId, contactoId, novedadId })),
    }),
  )(MenuNovedades),
);
